export const personTeams: TableModule = {
    name: 'personTeams',
    route: 'spa.organisations.persons.personLinks',
    defaultOrder: {
        column: 'type',
        direction: 'asc'
    },
    routeParams: [
        {
            param: 'organisation',
            prop: 'organisation_id'
        }, {
            param: 'person',
            prop: 'person_id'
        }
    ],
    columns: [
        {
            name: 'team_name',
            sortable: true,
            sortBy: 'team_name',
            mobile: true,
        },
        {
            name: 'type',
            sortable: true,
            mobile: true,
            breakpoint: 'md',
        },
    ],
    filters: [],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ['create', 'personLinks']
        }
    ]
}

